import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import ItemModify from '../Form/ItemModify';

@inject('dataOriginStore', 'dataOriginParameterStore', 'parameterStore', 'parameterUnitStore', 'dataSourceStore')
@observer
class DataSourceOriginParameterModify extends Component {

  componentWillMount() {
    const { dataOriginParameterStore, parameterStore, parameterUnitStore } = this.props;
    if (!dataOriginParameterStore.items.length && !dataOriginParameterStore.isLoading) dataOriginParameterStore.fetchItems();
    if (!parameterStore.items.length && !parameterStore.isLoading) parameterStore.fetchItems();
    if (!parameterUnitStore.items.length && !parameterUnitStore.isLoading) parameterUnitStore.fetchItems();
  }

  onSave = () => {
    const { params: { id }, dataSourceStore } = this.props;
    dataSourceStore.fetchItem(id, true);
  }

  render() {
    const { params: { id, dataOriginId, dataOriginParameterId }, dataOriginStore, dataOriginParameterStore, parameterStore, parameterUnitStore } = this.props;

    return (
      <ItemModify
        title='Data Origin Parameter'
        slug={`/daq/data-source/${id}/data-origin`}
        store={dataOriginParameterStore}
        itemFields={[
          { label: 'Id', key: 'id', editOnly: true, readOnly: true },
          { label: 'Data Origin', key: 'data_origin_id', type: 'select', options: dataOriginStore.items, fields: { label: 'code', value: 'id' }, defaultValue: dataOriginId, readOnly: true },
          { label: 'Code', key: 'code', type: 'text' },
          { label: 'Parameter', key: 'parameter_id', type: 'select', options: parameterStore.items, fields: { label: 'name', value: 'id' }, propagateTo: ['parameter_unit_id'] },
          { label: 'Parameter Unit', key: 'parameter_unit_id', type: 'select', options: parameterUnitStore.items, fields: { label: 'name', value: 'id' }, resolveFromParent: parameter_id => parameterStore.findById(parameter_id).parameter_unit_id },
          { label: 'Block', key: 'block', type: 'checkbox-numeric', defaultValue: 0, editOnly: true },
        ]}
        params={{ id: dataOriginParameterId }}
        onSave={this.onSave}
        isLoading={parameterStore.isLoading || parameterUnitStore.isLoading}
      />
    )
  }
}

export default DataSourceOriginParameterModify;



// WEBPACK FOOTER //
// ./src/components/DataSource/DataSourceOriginParametermodify.js